import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SchoolService } from '../Service/index';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  model: any = {};

  repassword: string;
  errorMsg = '';

  constructor(
    private router: Router,
    private schoolService: SchoolService,
  ) { }

  ngOnInit() {
  }


  register() {
    // Check if two password is same
    if(this.model.password != this.repassword){
      this.errorMsg = "two times password is different";
    }else {
      // Add new school to db
      this.schoolService.create(this.model)
        .subscribe(
          data => {
            this.router.navigate(['/login']);
          },
          error => {
            this.errorMsg = "Register fail, please try again";
          });
    }
  }


}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/register/register.component.ts